import { useSelector } from 'react-redux'
import styles from './DataTable.module.css'

const defaultData = {
  uid: 'UID123456',
  age: 32,
  standard_test: {
    name: 'MMSE',
    score: 26,
    diagnosed_conditions: ['Mild Cognitive Impairment'],
    date: '2025-06-21',
  },
  nema: {
    name: 'EEG scan',
    score: 87,
    diagnosed_conditions: ['ADHD', 'Mild Anxiety'],
    scan_date: '2025-06-20',
  },
  therapies_taken: 'Cognitive Behavioral Therapy, Occupational Therapy',
  past_data: 'Previous MMSE score: 24 (2024-12-15); Noted improvement after therapy.',
}

const CompareTable = ({ standard, nema }) => {
  const cols = [
    {
      label: 'Type',
      std: 'Standard Test',
      nema: 'NEMA Test',
    },
    {
      label: 'Name',
      std: standard?.name || '-',
      nema: nema?.name || '-',
    },
    {
      label: 'Score',
      std: standard?.score ?? '-',
      nema: nema?.score ?? '-',
    },
    {
      label: 'Diagnosed Conditions',
      std: standard?.diagnosed_conditions?.join(', ') || '-',
      nema: nema?.diagnosed_conditions?.join(', ') || '-',
    },
    {
      label: 'Date',
      std: standard?.date || '-',
      nema: nema?.scan_date || '-',
    },
  ]
  return (
    <div className={styles.compareTableColLayout}>
      {cols.map((col) => (
        <div className={styles.compareTableColCard} key={col.label} data-label={col.label?.toLowerCase()}>
          <div className={styles.compareTableColLabel}>{col.label}</div>

          <div className={styles.valueRow}>
            <span className={styles.valueRowValue}>{col.std}</span>
          </div>
          <div className={styles.valueRow}>
            <span className={styles.valueRowValue}>{col.nema}</span>
          </div>
        </div>
      ))}
    </div>
  )
}

const NeuroDataCard = ({ label, value }) => (
  <div className={styles.neuroDataCard}>
    <div className={styles.neuroDataCardLabel}>{label}</div>
    <div className={styles.neuroDataCardValue}>{value}</div>
  </div>
)

const NeuroDataTable = ({ data }) => {
  const { selectedUser } = useSelector((s) => s.user)

  const finalData = data || defaultData
  const { uid, age, standard_test, nema_test, therapies_taken, past_data } = finalData

  return (
    <div className={styles.neuroDataRoot}>
      <div className={styles.neuroDataRootBasic}>
        <NeuroDataCard label='User ID' value={selectedUser?.label || uid} />
        <NeuroDataCard label='Age' value={age} />
        <CompareTable standard={standard_test} nema={nema_test} />
      </div>

      <div className={styles.neuroDataRootBasic}>
        <NeuroDataCard label='Therapies Taken' value={therapies_taken || '-'} />
        <NeuroDataCard label='Past Data' value={past_data || '-'} />
      </div>
    </div>
  )
}

export default NeuroDataTable
